import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const MARKETING_EASE = [0.16, 1, 0.3, 1] as const;

export function MarketingAmbientGlow({
  background = "radial-gradient(circle, var(--interactive) 0%, transparent 60%)",
  className,
}: {
  background?: string;
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute top-[30%] left-1/2 rounded-full -translate-x-1/2 -translate-y-1/2",
        className,
      )}
      style={{ background }}
    />
  );
}

export function MarketingEyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="bg-[linear-gradient(90deg,#bff5ff,#d9c8ff)] bg-clip-text text-[10px] font-semibold tracking-[0.26em] text-transparent uppercase">
      {children}
    </span>
  );
}
